export const SUPPORT_TICKETS_PAGE_VIEW = {
  LIST_VIEW: "LIST_VIEW",
  TABLE_VIEW: "TABLE_VIEW",
  BOARD_VIEW: "BOARD_VIEW",
  MAP_VIEW: "MAP_VIEW",
} as const;

export type SupportTicketsPageView =
  (typeof SUPPORT_TICKETS_PAGE_VIEW)[keyof typeof SUPPORT_TICKETS_PAGE_VIEW];

export const SUPPORT_TICKET_BROADCAST_TOPICS = {
  REORDER_SUPPORT_TICKET_LIST: "REORDER_SUPPORT_TICKET_LIST",
  MEMBERSHIP_UPDATED: "MEMBERSHIP_UPDATED",
} as const;

export const SUPPORT_TICKETS_PAGE_VIEW_KEY = "supportTicketsPageView";

/**
 * PubNub message identifiers for Support Tickets. Deliberately distinct from
 * the Work Order ones (`ticketCreated`/`ticketUpdated`/`ticketDeleted`), and
 * carried with `userMetadata.isSupportTicket` rather than `isTicket`, so the
 * two unread buckets can never mix.
 */
export const SUPPORT_TICKET_CREATED_IDENTIFIER = "SUPPORT_TICKET_CREATED";
export const SUPPORT_TICKET_UPDATED_IDENTIFIER = "SUPPORT_TICKET_UPDATED";
export const SUPPORT_TICKET_DELETED_IDENTIFIER = "SUPPORT_TICKET_DELETED";

/**
 * A message was posted in a support ticket's external chat. Separate from
 * SUPPORT_TICKET_UPDATED for the same reason the Work Order variant is separate
 * from `ticketUpdated`: the update identifiers drive list reordering, this one
 * only refreshes unread counts. Gated on `!isInternal` by the publisher.
 */
export const SUPPORT_TICKET_CHAT_MESSAGE_IDENTIFIER =
  "SUPPORT_TICKET_CHAT_MESSAGE";

// Channel suffixes and isSupportTicketChannel moved to @shared/constants: the
// customer portal routes unread counts by them too, and the naming is a
// contract with the backend that must not exist in two copies.
export {
  SUPPORT_TICKET_EXTERNAL_CHANNEL_SUFFIX,
  SUPPORT_TICKET_INTERNAL_NOTES_CHANNEL_SUFFIX,
  isSupportTicketChannel,
} from "@shared/constants/supportTicketChannels";
